module.exports = __webpack_public_path__ + "static/media/bg-folio-big.44efb323.png";